import { render, staticRenderFns } from "./BOMType.vue?vue&type=template&id=5e2c77c2"
import script from "./BOMType.vue?vue&type=script&lang=js"
export * from "./BOMType.vue?vue&type=script&lang=js"
import style0 from "./BOMType.vue?vue&type=style&index=0&id=5e2c77c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports